import {Col, Container, Modal, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import {
  formatCurrency, isValidEvent, validEvent
} from "../../common/Utils";
import MDButton from "../../../components/MDButton";
import {addToCart, getInventoryEvent} from "../../common/api/PortalCustomerApi";
import Loading from "../../common/Loading";
import Avatar from "@mui/material/Avatar";
import {Card, CardContent, InputAdornment} from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import {CartContext} from "../../../lib/CartProvider";
import EventDetail from "../event/EventDetail";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EventMembershipDetail from "../event/EventMembershipDetail";
import Checkbox from "@mui/material/Checkbox";
import InventoryImage from "../event/InventoryImage";
import CheckIcon from '@mui/icons-material/Check';
import {Add, Remove} from "@mui/icons-material";
import MDInput from "../../../components/MDInput";
import FadeComponent from "../userinterface/FadeComponent";
import MDBox from "../../../components/MDBox";
import {useConfirm} from "../../common/Confirmation";
import {useDragScroll} from "../../common/ux/useDragScroll";

export default function RegisterEventModal(props) {

  const [cartContext, setCartContext] = useContext(CartContext);
  const [event, setEvent] = useState(props.event);
  const [addingToCart, setAddingToCart] = useState(false);
  const [eventLoading, setEventLoading] = useState(true);
  const [memberAccount, setMemberAccount] = useState(props?.event?.memberAccount);
  const {containerRef, dragHandlers} = useDragScroll();

  useEffect(() => {
    setMemberAccount(props?.event?.memberAccount);
  }, [props?.event?.memberAccount]);

  useEffect(() => {
    let _memberAccount = {...props?.event?.memberAccount};
    setEventLoading(true);
    getInventoryEvent(props?.event?.guid).then(r => {
      setEventLoading(false);
      let _e = {...r};
      _e.memberAccount = _memberAccount;
      setEvent(_e);
    });
  }, [props?.event]);

  const checkDisabled = (event) => {
    let isDisabled = false;
    if (addingToCart) {
      return true;
    }
    if (event?.eventType?.memberOnly && !event?.memberAccount?.id) {
      return true;
    }

    if (event?.packageRequired && selectedPackage === null) {
      return true;
    }
    return false;
  }

  const [addOnInventoryTypes, setAddOnInventoryTypes] = useState([]);

  const groupedAddOns = (event) => {
    let types = [];
    let oTypes = [];
    for (let j in event?.addOns) {
      if (types.indexOf(event.addOns[j]?.inventoryType?.id) === -1) {
        types.push(event.addOns[j]?.inventoryType?.id);
        let t = {...event.addOns[j].inventoryType};
        t.addOns = []
        t.addOns.push(event?.addOns[j])
        oTypes.push(t);
      } else {
        for (let k in oTypes) {
          if (oTypes[k]?.id === event.addOns[j]?.inventoryType?.id) {
            if (oTypes[k]?.addOns) {
              oTypes[k].addOns.push(event.addOns[j]);
            }
          }
        }
      }
    }
    setAddOnInventoryTypes(oTypes);
  }

  useEffect(() => {
    groupedAddOns(event);
  }, [event])

  const [doAddOns, setDoAddOns] = useState(false);

  useEffect(() => {
    setDoAddOns(false);
  }, [event]);

  const continueFromAddOns = () => {
    props.refreshCart();
  }

  const addToCartFn = async (event) => {

    let _event = {...event};
    _event.memberAccount = memberAccount;

    if (selectedPackage != null) {
      let sp = {...selectedPackage}
      if (packageAddOns != null) {
        sp.packageAddOns = [...packageAddOns];
      }
      _event.selectedPackage = {...sp};
    }

    setAddingToCart(true);

    addToCart(_event).then((result) => {
      setAddingToCart(false);
      if (event?.addOns?.length > 0) {
        setDoAddOns(true);
      } else {
        setCartContext({...cartContext, reloadCart: true, viewCart: true, caller: 'Register Add to cart fn'});
        handleClose();
      }
    });
  };

  const addOnToCartFn = async (item) => {
    let _item = {...item};
    item.addingToCart = true;
    addToCart(_item).then((result) => {
      item.addingToCart = false;
      item.addedToCart = true;
      setCartContext({...cartContext, reloadCart: true, caller: 'Register Event Modal (add on)'});
    });
  };

  const handleClose = () => {
    props.handleClose();
  };

  const handleCallback = (obj) => {
    if ('close' === obj) {
      handleClose();
    }
  }

  const [packageAddOns, setPackageAddOns] = useState([]);

  const togglePackageAddOn = (inv, selected) => {
    let pp = {...selectedPackage};
    let ppas = [...packageAddOns];
    if (selected) {
      ppas.push(inv);
    } else {
      let idx;
      for (let j in ppas) {
        if (ppas[j].id === inv.id) {
          idx = j;
        }
      }
      if (idx) {
        ppas.splice(idx, 1);
      }
    }
    setPackageAddOns(ppas);
    pp.packageAddOns = [...ppas];

    setSelectedPackage({...pp});
  }

  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    setPackageAddOns([]);
    setSelectedPackage(null);
  }, [event])

  const selectPackage = (pp, selected) => {
    setPackageAddOns([]);
    if (!selected) {
      setSelectedPackage(null)
    } else {
      setSelectedPackage(pp);
    }
  }

  const calculatePackageCost = () => {
    let basePrice = event?.price;
    if (selectedPackage) {
      basePrice += selectedPackage?.inventory?.price;
    }
    for (let j in packageAddOns) {
      basePrice += packageAddOns[j].price;
    }

    return formatCurrency(basePrice);
  }

  const packagePrice = (event, eventPackage) => {
    let eventPrice = parseFloat(event?.price);
    let packagePrice = parseFloat(eventPackage?.inventory?.price);
    let total = eventPrice + packagePrice;
    return formatCurrency(total);
  }

  const [viewWarning, setViewWarning] = useState(false);

  const toggleCalendarEventDetail = () => {
    setViewWarning(!viewWarning);
  }

  const registerMembershipEvent = async (event, memberAccount) => {
    if (event?.reservationStatus?.id > -1) {
      let _confirmation = {
        title: 'Registration',
        message: 'You are already registered for this event. Are you sure you wish to continue?'
      };
      setConfirmation(_confirmation);
      toggleCalendarEventDetail();

      const ok = await confirm(_confirmation);
      if (!ok) {
        setViewWarning(false);
        setConfirmation(null);
        return;
      }
      setViewWarning(false);
      setConfirmation(null);
    }

    let e = {...event};
    e.memberAccount = {...memberAccount};

    if (selectedPackage != null) {
      let sp = {...selectedPackage}
      if (packageAddOns != null) {
        sp.packageAddOns = [...packageAddOns];
      }
      e.selectedPackage = {...sp};
    }

    setAddingToCart(true);

    addToCart(e).then((result) => {
      setAddingToCart(false);
      if (event?.addOns?.length > 0) {
        setDoAddOns(true);
        return;
      }
      setCartContext({...cartContext, reloadCart: true, viewCart: true, caller: 'Register Add to cart fn'});
      handleClose();
    });

  }

  const [addonRenderIdx, setAddonRenderIdx] = useState(1);

  const updateAddOnQuantity = (addOn, quantity) => {
    addOn.quantity = quantity;
    setAddonRenderIdx(addonRenderIdx + 1);
  }

  const registerOptions = (row) => {
    if (!validEvent(row, 'registerOptions')) {
      return <MDButton variant="gradient"
                       color="info"
                       onClick={(e) => {
                       }}
                       disabled={true}>
        Registration Closed
      </MDButton>
    }

    if (!row?.eventType?.requireAttendees && row.memberAccountTypes?.length > 0) {
      return <div>
        {row.memberAccountTypes.map((_row, index) => {
          return (<MDButton onClick={() => registerMembershipEvent(row, _row)}
                            className="m-1"
                            key={index}
                            disabled={row.bookedFull}
                            color="info">
            {addingToCart ? 'Adding to Cart...' : <>{row.bookedFull ? 'Booked Full' : 'Register with ' + _row.name}</>}
          </MDButton>)
        })
        }
      </div>

    } else {
      return <div>
        <MDButton variant="gradient"
                  color="info"
                  onClick={async (e) => {

                    if (event?.reservationStatus?.id > -1) {
                      let _confirmation = {
                        title: 'Registration',
                        message: 'You are already registered for this event. Are you sure you wish to continue?'
                      };
                      setConfirmation(_confirmation);
                      toggleCalendarEventDetail();

                      const ok = await confirm(_confirmation);
                      if (!ok) {
                        setViewWarning(false);
                        setConfirmation(null);
                        return;
                      }
                      setViewWarning(false);
                      setConfirmation(null);
                    }
                    addToCartFn(row);
                  }}
                  disabled={checkDisabled(row)}>
          {addingToCart ? 'Adding to Cart...' : 'Add to Cart'}
        </MDButton>
      </div>
    }
  }

  const {confirm, ConfirmationDialog} = useConfirm();
  const [confirmation, setConfirmation] = useState(null);

  return (
    <>
      <Modal onHide={handleClose} size={'xl'} fullscreen={true} dialogClassName={'psb-page-overlay psb-overlay-wide'} show={viewWarning ? false : props.show}>
        {eventLoading && <Modal.Body>
          <Loading/>
        </Modal.Body>}
        {!eventLoading &&
          <form id={'registerEventForm'}>
            <Modal.Header closeButton>
              <Modal.Title>{event.eventType?.name} Registration</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col className={'col col-main'} xs={12}>
                  <Container>
                    {!doAddOns && <>
                      <Row>
                        {!selectedPackage && <>
                          <EventDetail
                            embedded={true}
                            showDesc={true}
                            event={event}
                            packages={true}
                            callback={handleCallback}
                          />
                        </>
                        }
                      </Row>

                      {validEvent(event, 'registermodal') && <>


                        {event?.packageRequired && <Row>

                          <h6>{selectedPackage ? 'Selected' : 'Choose'} Party Package</h6>

                          {event?.eventType?.eventPackageGroups?.sort((a, b) => a?.inventory?.price - b?.inventory?.price)
                            .filter((eventPackage)=> isValidEvent(event, eventPackage?.inventory?.eventType, "Package Filter"))
                            .map((eventPackage, index) => {
                            return (
                              <div className="mb-2" key={index} style={{
                                border: (eventPackage?.id === selectedPackage?.id) ? 'solid 1px #999' : 'solid 1px #ccc',
                                borderRadius: '12px',
                                margin: '4px auto',
                                width: '98%',
                                padding: '12px',
                                display: !selectedPackage ? 'block' : (eventPackage?.id === selectedPackage?.id ? 'block' : 'none'),
                                boxShadow: (eventPackage?.id === selectedPackage?.id) ? '0 0 2px #ff9900' : '0 0 2px #efefef',
                                background: '#fff'
                              }}>
                                <Grid container>
                                  <Grid item xs={3} sm={3}>
                                    {eventPackage?.inventory?.imageUrl ?
                                      <InventoryImage
                                        sx={{
                                          width: '100%',
                                          height: 'auto',
                                          margin: '-15px',
                                        }}
                                        inventory={eventPackage.inventory}/>
                                      : <span style={{fontSize: '42px'}}>&nbsp;</span>
                                    }
                                  </Grid>
                                  <Grid item xs={12} sm={9}>
                                    <h6>{eventPackage?.inventory?.name}</h6>
                                    <p>
                                      <b>Price: <span>{packagePrice(event, eventPackage)}</span></b>
                                    </p>

                                    {!selectedPackage && <>
                                      {eventPackage.inventory?.desc?.length > 0 && <>
                                        <Divider/>
                                        <div style={{
                                          clear: 'both',
                                          marginTop: '6px',
                                          whiteSpace: 'pre-wrap',
                                          fontSize: '0.875rem',
                                          marginBottom: '12px',
                                          maxWidth: '80%'
                                        }}>
                                          {eventPackage.inventory?.desc}
                                        </div>
                                      </>}

                                      {eventPackage.assignedInventories?.filter(a => a.included).length > 0 && <>
                                        <Grid container className={'psb-list-group'} style={{
                                          margin: '10px 0'
                                        }}>
                                          <div style={{
                                            width: '100%',
                                            display: 'block'
                                          }}>
                                            <Divider/>
                                            <h6>Included in package</h6>
                                          </div>
                                          {eventPackage.assignedInventories?.filter(a => a.included).map((inv, idx) => {
                                            return (
                                              <Grid item xs={12} sm={12} key={idx}>
                                                <Grid container>
                                                  <Grid item xs={11}>
                                                    <b>{inv.name}</b>
                                                    <p style={{
                                                      maxWidth: '80%'
                                                    }}><small>
                                                      {inv.desc}
                                                    </small>
                                                    </p>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            )
                                          })
                                          }
                                        </Grid>
                                      </>
                                      }
                                    </>}

                                    <MDButton
                                      sx={{margin: '10px 0'}}
                                      color="primary"
                                      size={"small"}
                                      className={'pull-right'}
                                      onClick={() => {
                                        selectPackage(eventPackage, eventPackage?.id !== selectedPackage?.id)
                                      }}>
                                      {eventPackage?.id === selectedPackage?.id ? <span>
                              <CheckIcon/>&nbsp;Selected Package
                            </span> : "Select Package"}
                                    </MDButton>

                                    {eventPackage.assignedInventories?.filter(a => !a.included).length > 0 &&
                                      <Grid style={{
                                        clear: 'both',
                                        width: '100%',
                                        display: eventPackage?.id === selectedPackage?.id ? 'block' : 'none'
                                      }}>
                                        <FadeComponent show={eventPackage?.id === selectedPackage?.id}>
                                          <>
                                            <Divider/>
                                            <h6>Choose Add-Ons</h6>
                                            <Grid container>
                                              {eventPackage.assignedInventories?.sort((a, b) => a.name.localeCompare(b.name))?.filter(a => !a.included).map((inv, idx) => {
                                                return (
                                                  <Grid item key={idx} sm={12} xs={12}>
                                                    <Grid container>
                                                      <Grid item xs={12}>
                                                        <label>
                                                          <Checkbox
                                                            disabled={eventPackage?.id !== selectedPackage?.id}
                                                            onClick={(e) => {
                                                              togglePackageAddOn(inv, e.target.checked)
                                                            }}
                                                          />
                                                          <b>{inv.name} {formatCurrency(inv.price)}</b>
                                                        </label>
                                                        <p style={{
                                                          paddingLeft: '40px',
                                                          maxWidth: '80%'
                                                        }}><small>{inv.desc}</small></p>
                                                      </Grid>
                                                    </Grid>
                                                  </Grid>
                                                )
                                              })
                                              }
                                            </Grid>
                                            <Divider/>
                                          </>
                                        </FadeComponent>
                                      </Grid>
                                    }
                                  </Grid>
                                </Grid>

                                {eventPackage?.id === selectedPackage?.id &&
                                  <h6 style={{
                                    float: 'right',
                                  }}>Total Price:&nbsp;
                                    <b>{calculatePackageCost()}</b></h6>}

                              </div>

                            )
                          })
                          }
                        </Row>}
                      </>}
                    </>
                    }

                    {doAddOns &&
                      <>
                        <Row>
                          <Col className={'col'} sm={12}>
                            <h4 htmlFor="name">Choose Add-Ons</h4>
                          </Col>
                        </Row>

                        <MDBox style={{
                          paddingTop: '16px',
                          position: 'sticky',
                          top: '-16px',
                          zIndex: '999',
                          background: '#fff',
                        }}>
                          {addOnInventoryTypes?.length > 0 && <>
                            <div className={'tab-container'} ref={containerRef} {...dragHandlers}>
                              <ul className={'tab-navigation'}>
                                {addOnInventoryTypes?.sort((a, b) => a.sortOrder - b.sortOrder).map((t, idx) => {
                                  return (
                                    <li key={idx} className={'tab-item'}>
                                      <MDButton
                                        onClick={(e) => {
                                          document.getElementById('addon-' + t.id)?.scrollIntoView({behavior: 'smooth'});
                                        }}
                                        style={{
                                          border: 'solid 1px #ddd',
                                          color: '#666',
                                          marginRight: '4px',
                                        }} size="small" variant="outlined">{t.name}</MDButton>
                                    </li>
                                  )
                                })
                                }
                              </ul>
                            </div>
                          </>}
                        </MDBox>

                        <div>
                          <FadeComponent show={doAddOns}>
                            {addOnInventoryTypes?.sort((o1, o2) => o1.sortOrder - o2.sortOrder).map((t, idx) => {
                              return (<div key={idx} className={'mb-3'}>
                              <span id={'addon-' + t.id} style={{
                                position: 'relative',
                                top: '-80px',
                                left: '-999em'
                              }}></span>
                                <h5>{t.name}</h5>
                                <Grid container alignItems="stretch">
                                  {t.addOns?.sort((a, b) => a.name.localeCompare(b.name)).map((addOn, index) => {
                                    return (
                                      <Grid item sm={12} md={4} xs={12} index={index} key={index} style={{
                                        paddingBottom: '12px'
                                      }}>
                                        <Card p={1} style={{
                                          height: '100%',
                                        }}>
                                          <CardContent style={{
                                            padding: 0
                                          }}>

                                            <InventoryImage
                                              sx={{
                                                width: '100%',
                                                height: 'auto',
                                              }}
                                              inventory={addOn}/>
                                            <h6 style={{
                                              marginTop: '4px'
                                            }}>
                                              {addOn.name}
                                            </h6>
                                            <p>{addOn.desc}</p>
                                            <p>Price: {formatCurrency(addOn.price)}</p>

                                            <div className={'d-block'}>
                                              <MDButton variant="gradient"
                                                        color="secondary"
                                                        size="small"
                                                        className={'pull-right mt-n1'}
                                                        onClick={(e) => {
                                                          addOnToCartFn(addOn)
                                                        }}
                                                        disabled={addOn.addingToCart || addOn.addedToCart || addOn.quantity <= 0}>
                                                &nbsp;{addOn.addingToCart && 'Adding to Cart...'}

                                                {!addOn.addingToCart && <>
                                                  {addOn.addedToCart ? (<>
                                                    <CheckCircleOutlineIcon/>&nbsp;Selected</>) : 'Add to Cart'}
                                                </>}
                                              </MDButton>
                                            </div>
                                            <div className={'d-block'}>
                                              {addonRenderIdx && <MDInput type="text" step="1"
                                                                          disabled={addOn.addedToCart}
                                                                          onChange={(e) => {
                                                                            updateAddOnQuantity(addOn, e.target.value)
                                                                          }}
                                                                          InputProps={{
                                                                            readOnly: true,
                                                                            startAdornment: <InputAdornment
                                                                              position="start"
                                                                              className={'cursor-pointer'}
                                                                              onClick={(e) => {
                                                                                let _q = addOn.quantity - 1;
                                                                                if (_q >= 0) {
                                                                                  updateAddOnQuantity(addOn, _q)
                                                                                  // setSiblingQuantity(_q);
                                                                                } else {
                                                                                  _q = 0;
                                                                                  updateAddOnQuantity(addOn, _q)
                                                                                }
                                                                              }}>
                                                                              <Remove/>
                                                                            </InputAdornment>,
                                                                            endAdornment: <InputAdornment position="end"
                                                                                                          className={'cursor-pointer'}
                                                                                                          onClick={(e) => {
                                                                                                            let _q = addOn.quantity;
                                                                                                            let _newQ = _q + 1;
                                                                                                            updateAddOnQuantity(addOn, _newQ)
                                                                                                          }}>
                                                                              <Add/>
                                                                            </InputAdornment>,
                                                                          }}
                                                                          value={addOn.quantity || 0}
                                                                          autoComplete="off"
                                                                          className="form-control" id="quantity"
                                                                          label="Quantity"
                                                                          style={{width: '125px'}}/>
                                              }
                                            </div>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    )
                                  })}
                                </Grid>
                              </div>)
                            })}
                          </FadeComponent>
                        </div>
                      </>
                    }
                  </Container>
                </Col>
              </Row>

            </Modal.Body>
            <Modal.Footer>

              {doAddOns && <>
                <MDButton variant="gradient"
                          color="info"
                          onClick={(e) => {
                            continueFromAddOns();
                          }}>
                  Continue
                </MDButton>
              </>}
              {!doAddOns && <>
                {registerOptions(event)}
              </>
              }

            </Modal.Footer>
          </form>
        }
      </Modal>

      {confirmation && <ConfirmationDialog/>}

    </>
  )
    ;
}